export const AppColors = {
	WHITE: '#FFFFFF',
	PRIMARY_DARK: '#5B21B6',
	TEXT_PRIMARY: '#101828',
	TEXT_SECONDARY: '#344054',
	TEXT_TERTIARY: '#475467',
	BORDER_GREY: '#EAECF0',
	LIGHTER_SHADE: '#D0D5DD',
	BACKGROUND_ACTIVE: '#F9FAFB',
	BACKGROUND_PRIMARY: '#F4EBFF',
	TEXT_SUCCESS: '#17B26A',
	TEXT_ERROR: '#D92D20',
	DARK_GREEN: '#079455',
	CHART_GREEN: '#9BDFC4',
	CHART_BLUE: '#62B2FD',
	CHART_PRIMARY_DARK: '#6941C6',
	CHART_PRIMARY_LIGHT: '#9E77ED',
	TEXT_RED: '#EF4444',
	DARK_GREY: '#667085',
	BLACK: '#000000',
	PRIMARY_BLUE: '#0A06F4',

	STATUS_GREEN: '#0B832F',
	STATUS_YELLOW: '#E28F10',
	STATUS_RED: '#BA1717',
	STATUS_GREY: '#b2b2b2',
	
	STATUS_HARASSMENT: '#BA1717',
	STATUS_SUICIDAL: '#E28F10',   


	// new ui colors

	// border color
	// Primary_shade: '#7F56D9', // used for logut icon
	BORDER_COLOR: '#DEDCDC',  // for navbar , 

	NEW_BACKGROUND: '#F6F8FA', // for background color of the page
	NEW_BACKGROUND4: '#F9F9F9', // for background color of the page

	// Primary_shade : "#7F56D9", // purple color for navlist items icon


	ERROR_DARKER : '#BA1717' ,
	ERROR_LIGHTER : '#FFC0C0', 

	SUCCESS_DARKER : '#0B832F' ,
	SUCCESS_LIGHTER : '#BDF2CD',

	WARNING_DARKER : '#E28F10' ,
	WARNING_LIGHTER : '#FDE9CB',

	// DARKER_PRIMARY : '#683FC7',
	
	BORDER_SECONDARY : '#F0F0F0',
	BORDER_TERTIARY : '#CACED0',
	

	LIGHT_GRAY : '#AFAFAF', 

	HEADING_TITLE : '#00041B',
	HEADING_TITLE2 : '#212126',
	HEADING_TITLE3 : '#35373F',
	HEADING_TITLE4 : '#545460', //Dark4
	HEADING_SUBTITLE : '#7C7C7C', 


	LIGHT1 : '#CACED0',
	LIGHT2 : '#DEE2E4',


	BAGROUND_SUCCESS : '#BDF2CD',
	BORDER_SUCCESS : '#31C25D',
	LABEL_SUCCESS : '#0B832F',

	BAGROUND_RED : '#FFC0C0',
	BORDER_RED : '#E56767',
	LABEL_RED : '#BA1717',

	BAGROUND_RED : '#FFC0C0',
	BORDER_RED : '#E56767',
	LABEL_RED : '#BA1717',

	BAGROUND_YELLOW : '#FDE9CB',
	BORDER_YELLOW : '#FFC061',
	LABEL_YELLOW : '#E28F10',

	BAGROUND_LIGHT : '#EEEFF0',
	BORDER_LIGHT : '#CACED0',
	LABEL_LIGHT : '#545460',


	Primary_shade: '#7F56D9',  
	DARKER_PRIMARY: '#683FC7', 
    LIGHT_SHADE : '#BFA8F4', 
    LIGHTER_SHADE: '#D8CFF9', 
	LIGHTEST_SHADE : "#ECE7FC",


    // '#7F56D9', 'Primary_shade',
	// '#683FC7','Darker-primary',
	// '#BFA8F4', 'Light-Shade',
	// '#D8CFF9','Lighter-Shade',
	// '#ECE7FC' ,'Lightest-shade',

};
